import { useEffect, useState } from 'react';

// Hooks
import {
    ADD_HASHTAG,
    REMOVE_HASHTAG,
    useAlbumContext
} from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

import Icon from '@/components/base/Icon';
// Components
import Label from '@/components/base/Label';
import SelectAlbumTags from '@/components/pages/albums/AlbumFunnelModal/components/SelectAlbumTags';

const HashtagsFilter = ({ hashtags }) => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();

    const [hashtagsOptions, setHashtagsOptions] = useState(null);

    useEffect(() => {
        if (hashtags && !hashtagsOptions) {
            setHashtagsOptions(
                hashtags?.map((hashtag) => {
                    return {
                        type: 'hashtag',
                        label: `#${hashtag}`,
                        value: hashtag
                    };
                })
            );
        }
    }, [hashtags]);

    if (albumInfo.criteria?.album_type) {
        return null;
    }

    return (
        <div>
            <Label className="flex items-center space-x-2.5 pb-2">
                <Icon icon="hashtag" className="text-sm text-icoBlue" />
                <span className="text-icoBlack dark:text-white">{t('modal.hashtags')}</span>
            </Label>
            <SelectAlbumTags
                placeholder={t('modal.choose_hashtags')}
                idInput="hashtags-search"
                options={hashtagsOptions?.filter(
                    (item) => !albumInfo?.criteria?.hashtags?.includes(item?.value)
                )}
                selectedItems={
                    hashtagsOptions?.filter((item) =>
                        albumInfo?.criteria?.hashtags?.includes(item?.value)
                    ) ?? []
                }
                addItem={(item) => {
                    dispatch({
                        type: ADD_HASHTAG,
                        payload: item.value
                    });
                }}
                removeItem={(item) => {
                    dispatch({
                        type: REMOVE_HASHTAG,
                        payload: item?.value
                    });
                }}
            />
        </div>
    );
};

HashtagsFilter.propTypes = {
    hashtags: PropTypes.array
};

export default HashtagsFilter;
